import React, { useState } from "react";
import "../Header/Header.css";
import { Link } from "react-router-dom";
import { TiThMenu } from "react-icons/ti";
import { IoIosCloseCircleOutline } from "react-icons/io";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };
  const calladmin = () => {
    window.location.href = 'tel:+919910171547';
  };
  
  return (
    <>
      <nav>
        <div className="wrapper-nav">
          <div className="logo">
            <Link to="/">
              <img src="logo2.png" className="logo-head" alt="logo" />
            </Link>
          </div>
          <input
            type="checkbox"
            id="menu-btn"
            checked={isMenuOpen}
            onChange={() => setIsMenuOpen(!isMenuOpen)}
          />
          <input type="radio" name="slider" id="close-btn" />
          <ul className={`nav-links ${isMenuOpen ? "active" : ""}`}>
            <label htmlFor="close-btn" className="btn close-btn">
            <IoIosCloseCircleOutline onClick={handleLinkClick} className="v-close"/>
            </label>
            <li>
              <Link to="/" onClick={handleLinkClick}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" onClick={handleLinkClick}>
                About
              </Link>
            </li>
            <li>
              <a href="#" className="desktop-item">
                Exclusive Projects
              </a>
              <input type="checkbox" id="showDropExclusive" />
              <label htmlFor="showDropExclusive" className="mobile-item">
                Exclusive Projects
              </label>
              <ul className="drop-menu2">
                <li>
                  <Link to="/exclusive1" onClick={handleLinkClick}>
                    RG Luxury
                  </Link>
                </li>
                <li>
                  <Link to="/exclusive2" onClick={handleLinkClick}>
                    IRISH Platinum
                  </Link>
                </li>
                <li>
                  <Link to="/exclusive3" onClick={handleLinkClick}>
                    Saviour Vridhi
                  </Link>
                </li>
                <li>
                  <Link to="/exclusive4" onClick={handleLinkClick}>
                    Trehan IRIS
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <a href="#" className="desktop-item">
                Projects
              </a>
              <input type="checkbox" id="showDropProjects" />
              <label htmlFor="showDropProjects" className="mobile-item">
                Projects
              </label>
              <ul className="drop-menu">
                <li>
                  <Link to="/residential" onClick={handleLinkClick}>
                    Residential
                  </Link>
                </li>
                <li>
                  <Link to="/commercial" onClick={handleLinkClick}>
                    Commercial
                  </Link>
                </li>
                <li>
                  <Link to="/officespace" onClick={handleLinkClick}>
                    Plots
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/contact" onClick={handleLinkClick}>
                Contact
              </Link>
            </li>
            <li>
              <button className="butt-nav" onClick={calladmin}>9910171547</button>
            </li>
          </ul>
          <label htmlFor="menu-btn" className="btn menu-btn">
            <TiThMenu className="menu-ic" />
          </label>
        </div>
      </nav>
    </>
  );
};

export default Header;
